import { BsArrowBarDown, BsArrowBarUp } from 'react-icons/bs';
import { Container } from 'react-bootstrap';
import { FC, useState } from 'react';
import { generalBlue } from 'src/app-config';
import { Hr } from 'src/components/_commons';
import { HTHAllBuildings, HTHAllDoNotCalls } from 'src/components/_commons/house-to-house';
import { typeHTHTerritory } from '@monorepo/models';
import { useGetConfig, useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    hthTerritory: typeHTHTerritory;
};

export const HTHSearcher: FC<propsType> = ({ hthTerritory }) => {
    const [showSearchSection, setShowSearchSection] = useState(false);
    const config = useGetConfig();
    const isMobile = useGetIsMobile();

    return (
        <Container>
            <h1 className={'container pointer btn-general-blue text-white py-3'}
                style={{
                    backgroundColor: generalBlue,
                    fontSize: isMobile ? '1.8rem' : '2.4rem',
                    fontWeight: 'bold',
                    margin: isMobile ? '30px auto 20px auto' : '60px auto 40px auto',
                    textAlign: 'center'
                }}
                onClick={() => setShowSearchSection(x => !x)}
            >
                {showSearchSection ?
                    'OCULTAR BUSCADOR '
                    :
                    'VER BUSCADOR '
                }
                {showSearchSection ?
                    <><BsArrowBarUp size={isMobile ? '1.6rem' : '1.4rem'} /></>
                    :
                    <><BsArrowBarDown size={isMobile ? '1.6rem' : '1.4rem'} /></>
                }
            </h1>
            {showSearchSection &&
                <>
                <Hr classes={'text-center my-5 mx-auto'} styles={{ maxWidth: isMobile ? '95%' : '85%' }} />
                <HTHAllDoNotCalls
                    hthTerritory={hthTerritory}
                />
                <Hr classes={'text-center my-5 mx-auto'} styles={{ maxWidth: isMobile ? '95%' : '85%' }} />
                <HTHAllBuildings
                    block={null}
                    congregationConfig={config}
                    hthTerritory={hthTerritory}
                />
                <Hr classes={'text-center mt-5 mx-auto'} styles={{ maxWidth: isMobile ? '95%' : '85%' }} />
                </>
            }
        </Container>
    );
}
